import styled from 'styled-components';
import { theme } from '../../theme/default';

export const ContentStyled = styled.div`
  background-color: var(--color-whitesmoke-300);
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
  position: relative;
`;
